import { Link } from 'react-router-dom';
import { ENLogo } from '@/components/ENLogo';
import NewsletterSubscribe from '@/components/NewsletterSubscribe';

export default function Footer() {
  return (
    <footer className="en-purple bg-[#0E0E23] text-white py-16 border-t border-white/10" data-testid="footer">
      <div className="container-main">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 md:gap-10 lg:gap-12">
          {/* Brand */}
          <div className="md:col-span-2 lg:col-span-1 lg:pr-4">
            <ENLogo size="sm" linkTo="/" />
            <p className="mt-4 text-[#9CA3AF] text-sm font-outfit leading-relaxed">
              Supporting Indigenous businesses worldwide through secure, trust-first marketplace connections.
            </p>
          </div>

          {/* For Consumers */}
          <div>
            <h4 className="font-outfit font-semibold text-white mb-4">For Consumers</h4>
            <ul className="space-y-3">
              <li><Link to="/browse" className="text-[#9CA3AF] hover:text-white transition-colors text-sm font-outfit" data-testid="footer-browse">Browse Vendors</Link></li>
              <li><Link to="/browse?category=cat_creative" className="text-[#9CA3AF] hover:text-white transition-colors text-sm font-outfit">Creative Services</Link></li>
              <li><Link to="/browse?category=cat_fashion" className="text-[#9CA3AF] hover:text-white transition-colors text-sm font-outfit">Fashion</Link></li>
              <li><Link to="/browse?category=cat_tech" className="text-[#9CA3AF] hover:text-white transition-colors text-sm font-outfit">Technology</Link></li>
              <li><Link to="/about" className="text-[#9CA3AF] hover:text-white transition-colors text-sm font-outfit" data-testid="footer-about">About</Link></li>
              <li><Link to="/contact" className="text-[#9CA3AF] hover:text-white transition-colors text-sm font-outfit" data-testid="footer-contact">Contact</Link></li>
            </ul>
          </div>

          {/* For Vendors */}
          <div>
            <h4 className="font-outfit font-semibold text-white mb-4">For Vendors</h4>
            <ul className="space-y-3">
              <li><Link to="/auth?mode=register&role=vendor" className="text-[#9CA3AF] hover:text-white transition-colors text-sm font-outfit">Start Selling</Link></li>
              <li><Link to="/create-website" className="text-[#9CA3AF] hover:text-white transition-colors text-sm font-outfit flex items-center gap-1">Create a Website <span className="bg-gradient-to-r from-purple-600 to-blue-500 text-white text-[9px] px-1 py-0.5 rounded font-bold">NEW</span></Link></li>
              <li><Link to="/pricing" className="text-[#9CA3AF] hover:text-white transition-colors text-sm font-outfit" data-testid="footer-pricing">Pricing</Link></li>
              <li><Link to="/trust-safety" className="text-[#9CA3AF] hover:text-white transition-colors text-sm font-outfit" data-testid="footer-trust">Trust & Safety</Link></li>
              <li><Link to="/faq" className="text-[#9CA3AF] hover:text-white transition-colors text-sm font-outfit" data-testid="footer-faq">FAQ</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-outfit font-semibold text-white mb-4">Legal</h4>
            <ul className="space-y-3">
              <li><Link to="/terms" className="text-[#9CA3AF] hover:text-white transition-colors text-sm font-outfit" data-testid="footer-terms">Terms of Service</Link></li>
              <li><Link to="/privacy" className="text-[#9CA3AF] hover:text-white transition-colors text-sm font-outfit" data-testid="footer-privacy">Privacy Policy</Link></li>
              <li><Link to="/refund" className="text-[#9CA3AF] hover:text-white transition-colors text-sm font-outfit" data-testid="footer-refund">Refund Policy</Link></li>
              <li><Link to="/legal/acceptable-use" className="text-[#9CA3AF] hover:text-white transition-colors text-sm font-outfit">Acceptable Use</Link></li>
              <li><Link to="/legal" className="text-[#9CA3AF] hover:text-white transition-colors text-sm font-outfit" data-testid="footer-legal">All Legal Documents</Link></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <NewsletterSubscribe />
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10">
          <p className="text-[#9CA3AF] text-sm font-outfit text-center max-w-4xl mx-auto leading-relaxed" data-testid="footer-marketplace-statement">
            EntrepreNatives is a marketplace platform connecting customers with independent Indigenous-owned
            businesses and service providers. We are not a party to transactions between vendors and buyers and
            are not a financial institution. All payment processing is handled by Stripe, a licensed payment
            processor — vendors receive their own payouts directly via Stripe Connect.
          </p>
          <p className="mt-4 text-[#64748B] text-xs font-outfit text-center">
            Need help? <Link to="/contact" className="underline hover:text-white">Contact us</Link> · <a href="mailto:support@entreprenatives.com" className="underline hover:text-white">support@entreprenatives.com</a>
          </p>
        </div>

        <div className="mt-8 pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[#64748B] text-sm font-outfit">
            &copy; {new Date().getFullYear()} EntrepreNatives. All rights reserved.
          </p>
          <p className="text-[#64748B] text-sm font-outfit">
            Supporting Indigenous economic empowerment.
          </p>
        </div>
      </div>
    </footer>
  );
}
